/*
  Lead attribution for HubSpot forms (decision D-1076). One file for every Clearlight theme.

  HubSpot's own source tracking needs its cookie, which our consent banner holds back until
  marketing consent, so many leads reached HubSpot as "Direct traffic". This file works out the
  traffic source in the browser and writes it into hidden contact fields on every HubSpot form:

    cl_first_source, cl_first_utm_source|medium|campaign|content|term, cl_first_landing_page,
    cl_first_referrer, cl_session_source, cl_session_landing_page, cl_gclid, cl_fbclid,
    cl_click_id_other, cl_posthog_distinct_id, cl_posthog_session_id, cl_analytics_consent

  A field only lands in HubSpot when the form has it (add it as a hidden field in the form editor).

  Consent: with analytics consent the first visit and the visit entry are kept in localStorage /
  sessionStorage, and click ids and PostHog ids are sent. Without it nothing is stored and only the
  current page is known: its source and landing page go out, device identifiers do not.

  Form paths: v4 embeds via HubSpotFormsV4.setFieldValue, v2 embeds (in page or in their
  same-origin iframe) by setting the hidden inputs, the cl-contact-form API path via
  clAttribution.hsFields().
*/
(function () {
  'use strict';
  if (window.clAttribution) return;

  var F_KEY = 'cl_att_f';
  var S_KEY = 'cl_att_s';
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var CLICK = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'li_fat_id'];
  // Our own sites, checkout and form hosts: a hop between them is not a new source.
  var OWN = /(^|\.)(clearlightsaunas\.(co|co\.uk|com\.au|com|eu)|clearlightinfrarotkabinen\.de|infraredsauna\.ie|clearlight-saunas\.[a-z.]+|infrared-sauna\.com\.au|infraredsauna\.co\.uk|myshopify\.com|shopify\.com|shop\.app|hsforms\.com|hsforms\.net|hubspot\.com|hs-sites\.com|hs-sites-eu1\.com|paypal\.com|klarna\.com|stripe\.com)$/i;
  var AI = [[/chatgpt\.com$|openai\.com$/, 'chatgpt'], [/perplexity\.ai$/, 'perplexity'], [/gemini\.google\.com$/, 'gemini'], [/copilot\.microsoft\.com$/, 'copilot'], [/claude\.ai$/, 'claude']];
  var ENGINES = [[/(^|\.)google\.[a-z.]+$/, 'google'], [/(^|\.)bing\.com$/, 'bing'], [/duckduckgo\.com$/, 'duckduckgo'], [/(^|\.)yahoo\.[a-z.]+$/, 'yahoo'], [/ecosia\.org$/, 'ecosia'], [/(^|\.)yandex\.[a-z.]+$/, 'yandex'], [/search\.brave\.com$/, 'brave'], [/(^|\.)qwant\.com$/, 'qwant']];
  var SOCIAL = [[/(^|\.)(facebook\.com|fb\.com|fb\.me)$/, 'facebook'], [/instagram\.com$/, 'instagram'], [/(^|\.)(t\.co|twitter\.com|x\.com)$/, 'x'], [/linkedin\.com$|lnkd\.in$/, 'linkedin'], [/youtube\.com$|youtu\.be$/, 'youtube'], [/pinterest\.[a-z.]+$/, 'pinterest'], [/tiktok\.com$/, 'tiktok'], [/reddit\.com$/, 'reddit']];

  function cut(v, n) { v = String(v == null ? '' : v); return v.length > n ? v.slice(0, n) : v; }
  function hostOf(u) { try { return new URL(u).hostname.replace(/^www\./, '').toLowerCase(); } catch (e) { return ''; } }
  function match(list, h) { for (var i = 0; i < list.length; i++) if (list[i][0].test(h)) return list[i][1]; return ''; }

  /* ------------------------------------------------------------- consent */
  // Same reading as cl-posthog.js: our banner where it runs, the Shopify Customer Privacy API elsewhere.
  function consent() {
    if (window.clConsent && typeof clConsent.get === 'function') {
      var s = clConsent.get();
      return { decided: !!s.decided, analytics: !!s.analytics };
    }
    var cp = window.Shopify && Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
      return { decided: true, analytics: !!cp.analyticsProcessingAllowed() };
    }
    return { decided: false, analytics: false };
  }
  function consentLabel(c) { return c.analytics ? 'granted' : (c.decided ? 'denied' : 'undecided'); }

  /* --------------------------------------------------------------- touch */
  function sourceOf(t) {
    if (t.utm_source || t.utm_medium) return (t.utm_source || '(not set)') + ' / ' + (t.utm_medium || '(not set)');
    if (t.gclid || t.gbraid || t.wbraid) return 'google / cpc';
    if (t.msclkid) return 'bing / cpc';
    if (t.fbclid) return 'facebook / fbclid';
    if (t.ttclid) return 'tiktok / cpc';
    if (t.li_fat_id) return 'linkedin / cpc';
    var h = t.ref;
    if (h) {
      var n = match(AI, h);
      if (n) return n + ' / ai';
      n = match(ENGINES, h);
      if (n) return n + ' / organic';
      n = match(SOCIAL, h);
      if (n) return n + ' / social';
      if (/^android-app:|mail\.|outlook\.|gmail/.test(h)) return h + ' / email';
      return h + ' / referral';
    }
    return '(direct) / (none)';
  }

  // What this page view says about where the visitor came from.
  function currentTouch() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { q = { get: function () { return null; } }; }
    var t = { at: new Date().toISOString(), lp: '', ref: '' };
    UTM.concat(CLICK).forEach(function (k) { var v = q.get(k); if (v) t[k] = cut(v, 250); });
    // Landing page without click ids: those are identifiers and have their own fields.
    var qs = location.search.replace(/^\?/, '').split('&').filter(function (kv) { return kv && CLICK.indexOf(kv.split('=')[0]) < 0; }).join('&');
    t.lp = cut(location.hostname.replace(/^www\./, '') + location.pathname + (qs ? '?' + qs : ''), 480);
    var rh = hostOf(document.referrer);
    if (rh && !OWN.test(rh) && rh !== location.hostname.replace(/^www\./, '').toLowerCase()) t.ref = rh;
    t.src = sourceOf(t);
    // A tagged URL or an outside referrer starts a new visit entry; an internal hop does not.
    t.entry = !!(t.ref || t.utm_source || t.utm_medium || t.utm_campaign || CLICK.some(function (k) { return t[k]; }));
    return t;
  }

  function read(store, key) { try { return JSON.parse(window[store].getItem(key) || 'null'); } catch (e) { return null; } }
  function write(store, key, v) { try { window[store].setItem(key, JSON.stringify(v)); } catch (e) { /* storage off */ } }
  function drop() { try { localStorage.removeItem(F_KEY); sessionStorage.removeItem(S_KEY); } catch (e) { /* storage off */ } }

  var here = currentTouch();
  var state = { f: null, s: null };

  function sync() {
    var c = consent();
    if (!c.analytics) {
      if (c.decided) drop();
      // Nothing stored: this page is all we know.
      state.s = here;
      state.f = null;
      return;
    }
    var s = read('sessionStorage', S_KEY);
    if (!s || here.entry) { s = here; write('sessionStorage', S_KEY, s); }
    var f = read('localStorage', F_KEY);
    if (!f) { f = s; write('localStorage', F_KEY, f); }
    state.s = s;
    state.f = f;
  }
  sync();

  /* -------------------------------------------------------------- values */
  function posthogIds(c) {
    var ph = window.posthog;
    if (!c.analytics || !ph || !ph.__loaded) return {};
    var out = {};
    try {
      var d = ph.get_distinct_id();
      if (d && !/cookieless/i.test(d)) out.cl_posthog_distinct_id = cut(d, 200);
      var sid = ph.get_session_id && ph.get_session_id();
      if (sid) out.cl_posthog_session_id = cut(sid, 200);
    } catch (e) { /* SDK not ready */ }
    return out;
  }

  function values() {
    sync();
    var c = consent();
    var s = state.s || here;
    var f = state.f || s;            // first known visit: the stored one, else this visit
    var v = {
      cl_first_source: f.src,
      cl_first_utm_source: f.utm_source,
      cl_first_utm_medium: f.utm_medium,
      cl_first_utm_campaign: f.utm_campaign,
      cl_first_utm_content: f.utm_content,
      cl_first_utm_term: f.utm_term,
      cl_first_landing_page: f.lp,
      cl_first_referrer: f.ref,
      cl_session_source: s.src,
      cl_session_landing_page: s.lp,
      cl_analytics_consent: consentLabel(c)
    };
    if (c.analytics) {
      // Device identifiers only with consent (same rule as cl-posthog.js).
      v.cl_gclid = s.gclid || s.gbraid || s.wbraid || f.gclid || f.gbraid || f.wbraid;
      v.cl_fbclid = s.fbclid || f.fbclid;
      var other = [];
      ['msclkid', 'ttclid', 'li_fat_id'].forEach(function (k) { var x = s[k] || f[k]; if (x) other.push(k + '=' + x); });
      v.cl_click_id_other = other.join('; ');
      var ids = posthogIds(c);
      for (var k in ids) v[k] = ids[k];
    }
    var out = {};
    for (var key in v) if (v[key]) out[key] = cut(v[key], 500);
    return out;
  }
  var NAMES = ['cl_first_source', 'cl_first_utm_source', 'cl_first_utm_medium', 'cl_first_utm_campaign', 'cl_first_utm_content', 'cl_first_utm_term', 'cl_first_landing_page', 'cl_first_referrer', 'cl_session_source', 'cl_session_landing_page', 'cl_gclid', 'cl_fbclid', 'cl_click_id_other', 'cl_posthog_distinct_id', 'cl_posthog_session_id', 'cl_analytics_consent'];

  /* --------------------------------------------------- v4 embeds (hs-form-frame) */
  var v4Forms = [];
  function fillV4(entry) {
    var form = entry.form;
    if (!entry.names.length || typeof form.setFieldValue !== 'function') return;
    var v = values();
    entry.names.forEach(function (n) {
      try { form.setFieldValue('0-1/' + n, v[n] || ''); } catch (e) { /* form re-rendered */ }
    });
  }
  window.addEventListener('hs-form-event:on-ready', function (e) {
    var form = null;
    try { form = window.HubSpotFormsV4 && HubSpotFormsV4.getFormFromEvent ? HubSpotFormsV4.getFormFromEvent(e) : null; } catch (err) { /* ignore */ }
    if (!form || typeof form.getFormFieldValues !== 'function') return;
    // Only touch the fields this form has (hidden fields included), so other forms stay quiet.
    form.getFormFieldValues().then(function (list) {
      var have = (list || []).map(function (x) { return String(x.name || '').replace(/^0-1\//, ''); });
      var entry = { form: form, names: NAMES.filter(function (n) { return have.indexOf(n) > -1; }) };
      if (!entry.names.length) return;
      v4Forms.push(entry);
      fillV4(entry);
    }).catch(function () { /* values unavailable */ });
  });

  /* ------------------------------------- v2 embeds and any form with the inputs */
  var setter = (function () { try { return Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set; } catch (e) { return null; } })();
  function setInput(el, val) {
    if (el.value === val) return;
    // The v2 renderer is React: set through the native setter and announce it, or the value is lost.
    if (setter) setter.call(el, val); else el.value = val;
    try {
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) { /* old browser */ }
  }
  var SEL = NAMES.map(function (n) { return 'input[name="' + n + '"]'; }).join(',');
  function fillDoc(doc) {
    var list;
    try { list = doc.querySelectorAll(SEL); } catch (e) { return 0; }
    if (!list.length) return 0;
    var v = values();
    for (var i = 0; i < list.length; i++) setInput(list[i], v[list[i].name] || '');
    return list.length;
  }
  var hooked = [];
  function fillAll() {
    fillDoc(document);
    var frames = document.querySelectorAll('iframe');
    for (var i = 0; i < frames.length; i++) {
      var doc = null;
      try { doc = frames[i].contentDocument; } catch (e) { doc = null; }   // cross-origin: not ours
      if (!doc) continue;
      if (fillDoc(doc) && hooked.indexOf(doc) < 0) {
        hooked.push(doc);
        // Last refresh right before the form posts (PostHog ids may have loaded meanwhile).
        doc.addEventListener('submit', function (e) { fillDoc(e.target.ownerDocument || document); }, true);
      }
    }
    v4Forms.forEach(fillV4);
  }
  document.addEventListener('submit', function () { fillDoc(document); }, true);
  window.addEventListener('message', function (e) {
    var d = e.data;
    if (d && typeof d === 'object' && d.type === 'hsFormCallback' && d.eventName === 'onFormReady') setTimeout(fillAll, 0);
  });
  // The SDK and consent settle after the forms render: refresh a few times, then on every change.
  [1500, 4000, 9000].forEach(function (t) { setTimeout(fillAll, t); });
  document.addEventListener('cl:consent', function () { setTimeout(fillAll, 50); });
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.form && t.form.querySelector && t.form.querySelector(SEL)) fillAll();
  });
  // Focus moving into a form iframe blurs this window: refresh before the visitor types.
  window.addEventListener('blur', function () {
    setTimeout(function () { var a = document.activeElement; if (a && a.tagName === 'IFRAME') fillAll(); }, 0);
  });

  /* ------------------------------------------- cl-contact-form (submissions API) */
  function hsFields() {
    var v = values();
    return NAMES.filter(function (n) { return v[n]; }).map(function (n) { return { objectTypeId: '0-1', name: n, value: v[n] }; });
  }

  window.clAttribution = { values: values, hsFields: hsFields, names: NAMES, fill: fillAll };
})();
